import * as React from "react"
import { SVGProps } from "react"

const SvgArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M13.525 17.1q-.225-.225-.225-.538 0-.312.225-.537l3.3-3.275H5.05q-.325 0-.537-.213Q4.3 12.325 4.3 12t.213-.538q.212-.212.537-.212h11.775L13.5 7.95q-.2-.225-.2-.525t.225-.525q.225-.25.525-.25t.55.25l4.475 4.475q.125.125.188.287.062.163.062.338t-.062.337-.188.288l-4.5 4.5q-.225.225-.525.225t-.525-.25"
    />
  </svg>
)
export default SvgArrowRight
